import script from "./Downloads.vue?vue&type=script&setup=true&lang=js"
export * from "./Downloads.vue?vue&type=script&setup=true&lang=js"

import "./Downloads.vue?vue&type=style&index=0&id=50f71b14&lang=scss"

const __exports__ = script;

export default __exports__